import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { shouldDisableServiceWorker, isInIframe, isLovablePreviewHost } from './lib/pwaEnvironment'

// Désactive complètement le ServiceWorker en dev, iframe ou preview Lovable.
// Évite le shell PWA figé qui produit des écrans blancs dans le preview.
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  if (shouldDisableServiceWorker()) {
    console.log('[PWA] Environnement preview/dev/iframe détecté → désinscription du SW', {
      iframe: isInIframe(),
      previewHost: isLovablePreviewHost(),
      dev: import.meta.env.DEV,
    })
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister().catch((error) => {
            console.warn('[PWA] Échec de la désinscription du service worker', error)
          })
        })
      })
      .catch(() => {})
    if ('caches' in window) {
      caches
        .keys()
        .then((names) => Promise.all(names.map((n) => caches.delete(n))))
        .catch(() => {})
    }
  }
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

